
<div class="overlapping-entities"
     style="position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%);
            z-index: 2000; min-width: 250px; max-width: 90vw;">

  <div class="card shadow rounded">
    <div class="card-header d-flex justify-content-between align-items-center bg-primary text-white py-2 px-3">
      <h6 class="mb-0">Overlapping Entities ({{ entities.length }})</h6>
      <button class="btn-close btn-close-white btn-sm" (click)="closeOverlappingEntities()"></button>
    </div>

    <div class="card-body p-2">
      <div class="list-group custom-scroll overlapping-entity scrollable">
        @for (entity of entities; track entity) {
          <button
            class="list-group-item list-group-item-action d-flex align-items-center gap-2"
            (click)="navigateToBuilding(entity)"
            [class.disabled]="entity.active"
            >
            <img [src]="entity.icon || 'assets/img/default_entity.png'" alt="img/default_entity.png" width="24" height="24">
            {{ entity.name }}
          </button>
        }
      </div>
    </div>
  </div>
</div>
